import { createSvgComponent } from "../../icon/createSvgComponent";
import Chevronleft from "@core/__generated__/icon/figma/chevronleft.svg";
export default createSvgComponent(Chevronleft);